var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMultiplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3L14.1132 8H19.8868L17 3ZM16.5 7.5V11H17.5V7.5H16.5Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6474 28.9687C19.775 28.9896 19.8973 29 20.0196 29C20.9608 29 21.7584 28.3419 21.9817 27.4384C22.7686 24.2317 24.9912 16.5649 24.9912 14.5803C24.9912 12.0525 22.9016 10 20.328 10C19.674 10 19.0519 10.1306 18.4883 10.3708C18.0151 10.5693 17.5046 10.6737 16.9941 10.6737C16.4837 10.6737 15.9732 10.5745 15.5 10.3708C14.9364 10.1306 14.3143 10 13.6603 10C11.0867 10 8.99707 12.0525 8.99707 14.5803C8.99707 16.3194 11.1984 24.2317 11.9694 27.4384C12.1874 28.3419 12.985 29 13.9314 29C14.0537 29 14.1813 28.9896 14.309 28.9634C15.2661 28.7859 15.9307 27.9241 15.9307 26.9684V24.7905C15.9307 23.9601 16.3986 23.5006 16.9782 23.5006C17.5578 23.5006 18.0257 23.9601 18.0257 24.5294V26.9684C18.0257 27.9241 18.6903 28.7911 19.6528 28.9687H19.6474Z",
    fill: "#70A4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01169 13L0.717457 18.766L5.85807 16.1378L1.01169 13ZM33 13L28.1099 16.0692L33.2129 18.7696L33 13ZM2.73954 17.3907C4.85025 19.1573 8.8668 20.7687 16.4909 20.9998L16.5212 20.0002C8.99935 19.7722 5.24546 18.184 3.38136 16.6239L2.73954 17.3907ZM16.4909 20.9998C24.752 21.2502 29.0262 19.3907 31.2349 17.3446L30.5553 16.611C28.6121 18.4111 24.6397 20.2463 16.5212 20.0002L16.4909 20.9998Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 29L19.8868 24H14.1132L17 29ZM17.5 24.5V20H16.5V24.5H17.5Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultiplane);
export default __webpack_public_path__ + "static/media/Icon_Multiplane.cf95f21d299365c40673319b460340de.svg";
export { ForwardRef as ReactComponent };